import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciSearchComponent } from './luci-search.component';
import { FormsModule } from '@angular/forms';
import {ListSearchPipeModule} from '../commons/pipes/list-search/list-search.pipe.module';
import {SearchFilterPipeModule} from '../commons/pipes/search-filter/search-filter.pipe.module';


@NgModule({
  declarations: [LuciSearchComponent],
  exports: [LuciSearchComponent],
  imports: [
    CommonModule,
    FormsModule,
    SearchFilterPipeModule,
    ListSearchPipeModule
  ]
})
export class LuciSearchModule { }
